import React from "react";
import { Map, List } from "lucide-react";

export type DashboardView = "list" | "map";

interface DashboardViewToggleProps {
  activeView: DashboardView;
  onViewChange: (view: DashboardView) => void;
  className?: string;
}

const DashboardViewToggle: React.FC<DashboardViewToggleProps> = ({
  activeView,
  onViewChange,
  className = "",
}) => {
  return (
    <div className={`flex bg-gray-100 rounded-lg p-1 ${className}`}>
      <button
        onClick={() => onViewChange("list")}
        className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          activeView === "list"
            ? "bg-white text-blue-600 shadow-sm"
            : "text-gray-600 hover:text-gray-800"
        }`}
      >
        <List className="w-4 h-4" />
        <span>List View</span>
      </button>
      <button
        onClick={() => onViewChange("map")}
        className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          activeView === "map"
            ? "bg-white text-blue-600 shadow-sm"
            : "text-gray-600 hover:text-gray-800"
        }`}
      >
        <Map className="w-4 h-4" />
        <span>Map View</span>
      </button>
    </div>
  );
};

export default DashboardViewToggle;
